const pathAKeeps = [
  'Bağımsız yaşam döngülerine sahip ayrı depolama dizileri',
  'Ürünler arası koordinasyon yükü',
  'Çok satıcılı destek ilişkileri',
  'Donanım yenileme döngüsü uyumsuzluğu',
  'Ekip uzmanlığı parçalanması',
];

const pathAChanges = ['Lisans satıcısı ve maliyetleri', 'Hiper yönetici yönetim arayüzü', 'Ekip eğitim gereksinimleri'];

const pathBChanges = [
  'Lisans maliyetleri kaldırıldı (platforma dahil)',
  'Tek platform beş ürünün yerini aldı',
  'Tek yükseltme yolu koordinasyonu ortadan kaldırdı',
  'Birleşik tanı çok satıcılı sorun gidermenin yerini aldı',
  'Platform düzeyinde verimlilik sunucu sayısını %30-40 azaltıyor',
];

const pathBHardware = [
  'Mevcut VxRail ve standart x86 sunucularında çalışır',
  'Sermaye gereksinimleri neredeyse sıfıra düşer',
  'Satıcı donanım kilidi yok',
];

export default function OBPaths() {
  return (
    <section className="py-20 bg-[#f8fafc] border-y border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">İki Yol. İki Sonuç.</h2>
        <div className="mb-10 rounded-xl overflow-hidden border border-gray-100">
          <img
            src="https://www.verge.io/wp-content/uploads/2026/02/Pivot-to-PC.png"
            alt="Özel Buluta Geçiş Diyagramı"
            className="w-full object-top"
          />
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {/* Path A */}
          <div className="bg-white rounded-lg border border-gray-200 p-7">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-7 h-7 flex items-center justify-center bg-gray-200 rounded-full text-gray-600 text-xs font-bold">A</span>
              <h3 className="font-bold text-[#1e293b] text-base">Yol A: Hiper Yönetici Değiştirme</h3>
            </div>
            <p className="text-xs text-gray-600 mb-4 leading-relaxed">
              Mevcut altyapı mimarisini koruyarak sanallaştırma platformunu veya OpenStack ile değiştirme.
            </p>
            <p className="text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">Ne Değişir:</p>
            <ul className="space-y-1.5 mb-4">
              {pathAChanges.map(i => (
                <li key={i} className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-[#e8600a] mt-0.5 shrink-0"></i>{i}
                </li>
              ))}
            </ul>
            <p className="text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">Ne Aynı Kalır:</p>
            <ul className="space-y-1.5">
              {pathAKeeps.map(i => (
                <li key={i} className="flex items-start gap-2 text-xs text-gray-500">
                  <i className="ri-close-line text-red-400 mt-0.5 shrink-0"></i>{i}
                </li>
              ))}
            </ul>
          </div>
          {/* Path B */}
          <div className="bg-white rounded-lg border-2 border-[#e8600a] p-7 relative">
            <div className="absolute -top-3 left-6 bg-[#e8600a] text-white text-xs font-bold px-3 py-1 rounded-full">Önerilen</div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-7 h-7 flex items-center justify-center bg-[#e8600a] rounded-full text-white text-xs font-bold">B</span>
              <h3 className="font-bold text-[#1e293b] text-base">Yol B: Özel Bulut İşletim Sistemi Konsolidasyonu</h3>
            </div>
            <p className="text-xs text-gray-600 mb-4 leading-relaxed">
              Hesaplama, depolama, ağ ve veri korumasını mevcut donanımda çalışan birleşik bir platformda birleştirme.
            </p>
            <p className="text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">Ne Değişir:</p>
            <ul className="space-y-1.5 mb-4">
              {pathBChanges.map(i => (
                <li key={i} className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-[#e8600a] mt-0.5 shrink-0"></i>{i}
                </li>
              ))}
            </ul>
            <p className="text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">Donanım Etkisi:</p>
            <ul className="space-y-1.5">
              {pathBHardware.map(i => (
                <li key={i} className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-[#e8600a] mt-0.5 shrink-0"></i>{i}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
